<template>
  <div>
    <v-dialog v-model="isAdding" width="500px">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>Create A new Limit</span>
          <v-btn text icon dark @click="isAdding = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <limit-form @limitCreated="limitCreated" :userId="userId" />
        </v-container>
      </v-card>
    </v-dialog>
    <data-table
      :headers="headers"
      :fields="fields"
      :url="url"
      title="Crypto Limits"
      item-key="id"
      ref="table"
      searchable
    >
      <v-btn slot="action.icons" color="primary" tile @click="isAdding = true">
        <v-icon>mdi-plus</v-icon>
        New Limit
      </v-btn>
      <template slot="item.actions" slot-scope="{ item }">
        <v-btn small icon @click="destroyRate(item)">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>
      </template>
    </data-table>
  </div>
</template>
<script>
import LimitForm from "./form";
export default {
  components: { LimitForm },
  props: { userId: { type: String } },
  data() {
    return {
      isAdding: false,

      headers: {
        currency: "Currency",
        daily: "Daily Limit",
        weekly: "Weekly Limit",
        monthly: "Monthly Limit",
        annual: "Annual Limit",
        actions: "Actions",
      },
      fields: {
        daily: { type: "currency", default: "--" },
        weekly: { type: "currency", default: "--" },
        monthly: { type: "currency", default: "--" },
        annual: { type: "currency", default: "--" },
        currency: {
          format: (value) => value && this.titleCase(`${value.name} (${value.short_name})`),
          default: "N/A",
        },
      },
    };
  },
  methods: {
    limitCreated() {
      this.isAdding = false;
      window.Notify.success("Limit was created successfully");
      this.$refs.table.fetchData();
    },
    destroyRate(rate) {
      Notify.confirm("Rate will be destroyed").then(() => {
        this.$http.delete(`api/v1/cryptoLimits/${rate.id}`).then(() => {
          this.$refs.table.fetchData();
          window.Notify.success("Limit was deleted successfully");
        });
      });
    },
  },
  computed: {
    url() {
      const id = this.userId;
      return id ? `/api/v1/cryptoLimits?userId=${id}` : "/api/v1/cryptoLimits?global=true";
    },
  },
};
</script>
